/** Race a track promise against a timeout so hung SDKs never brick navigation. */
export function awaitTrack(
  trackPromise: Promise<unknown> | undefined,
  timeoutMs = 300,
): Promise<void> {
  if (!trackPromise) return Promise.resolve();
  let timer: ReturnType<typeof setTimeout>;
  return Promise.race([
    trackPromise.then(() => undefined),
    new Promise<void>(resolve => {
      timer = setTimeout(resolve, timeoutMs);
    }),
  ]).finally(() => clearTimeout(timer));
}
